import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';
import { MatTabsModule } from '@angular/material/tabs';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ModalComponent } from '../modal/modal.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdateService } from '../../core/services/update.service';
import { Constants } from '../../shared/utils/constants';
import { HttpClient } from '@angular/common/http';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { forkJoin } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-general',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    MatCheckboxModule,
    ReactiveFormsModule,
  ],
  templateUrl: './general.component.html',
  styleUrl: './general.component.scss',
})
export class GeneralComponent implements OnInit {
  alerts: Alert[] = [];
  flattenedData: { [key: string]: any[] } = {
    [Constants.SEGURIDAD]: [],
    [Constants.OPERACION]: [],
    [Constants.PERSONAL]: [],
    [Constants.DESPACHO]: [],
  };

  tableColumns: TableColumn[] = [
    {
      header: 'Seleccionar',
      field: 'isMarkedForClosure',
      isCheckbox: true,
      showSelectAll: true,
      width: '120px',
    },
    { header: 'Hora', field: 'hora' },
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'Novedad', field: 'novedad' },
    { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  tableColumnsSeguridad: TableColumn[] = [
    {
      header: 'Seleccionar',
      field: 'isMarkedForClosure',
      isCheckbox: true,
      showSelectAll: true,
      width: '120px',
    },
    { header: 'Hora', field: 'hora' },
    { header: 'Tipo', field: 'tipo' }, // Cambiado de 'updateType.name' a 'tipo'
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'Novedad', field: 'novedad' },
    { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  formGroups: { [key: string]: FormGroup } = {};
  groupedData: { [key: string]: any } = {};
  updateData: { [key: string]: any } = {};

  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private updateService: UpdateService,
    private fb: FormBuilder,
  private http: HttpClient,
  private shiftClosureService: ShiftClosureService,
  private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loadData(Constants.SEGURIDAD);
    // this.loadData(Constants.OPERACION);
    this.loadData(Constants.PERSONAL);
    // this.loadData(Constants.DESPACHO);
    // this.loadTabData(Constants.OPERACION);
    // this.loadTabData(Constants.DESPACHO);
  }

  loadData(type: string): void {

    const isClosed = false;
    const isMarkedForClosure = undefined;
    const isMarkedForPreClosure = false;

    this.updateRecordService.getUpdateRecordsByTypeAndAreas(
      type,
      [Constants.GENERAL],
      isClosed,
      isMarkedForClosure,
      isMarkedForPreClosure,
      true // Forzar scope por usuario en "Mis novedades"
    ).subscribe({
      next: (updates: UpdateRecord[]) => {
        const flattened = this.flattenData(updates);
        this.flattenedData[type] = flattened.length ? flattened : [];
      },
      error: error => {
        if (error.status === 404) {
          this.flattenedData[type] = [];
        } else {
          console.error(`Error al cargar los datos para el tipo ${type}:`, error);
          this.flattenedData[type] = [];
        }
      },
    });
  }
  

  newUpdateRecord(type: string) {
    // Verificar si hay un turno abierto antes de abrir el modal
  this.shiftClosureService.getOpenShiftByType('informe_turno')
      .subscribe({
        next: (shiftId: number) => {
          if (!shiftId) {
            alert('Error: No existe un turno abierto para registrar información');
          } else {
            // Si no contiene el mensaje de error, proceder a abrir el modal
            const dialogRef = this.dialog.open(ModalComponent, {
              data: { type, area: Constants.GENERAL },
              width: '600px',
            });

            dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
              if (result?.success) {
                this.loadData(type);
              }
            });
          }
        },
  error: (error: any) => {
          // Si hay un error en la llamada al API
          alert('Error: No existe un turno abierto para registrar información');
          console.error('Error al verificar el turno abierto:', error);
        }
      });
  }

  // Determina la marca de cierre a mostrar según rol (sin fallback por área)
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const isDcs = this.authService.hasRole('Novedades_Operador_DCS') || this.authService.hasRole('DCS') || this.authService.hasRole('dcs');
    const isFerrico = this.authService.hasRole('Novedades_Operador_Ferrico') || this.authService.hasRole('FERRICO') || this.authService.hasRole('ferrico');
    if (isDcs) {
      return (u.isMarkedForClosureDCS ?? u.isMarkedForClosureDcs ?? update.isMarkedForClosure) as boolean;
    }
    if (isFerrico) {
      return (u.isMarkedForClosureFerrico ?? update.isMarkedForClosure) as boolean;
    }
    return update.isMarkedForClosure;
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      const horaElement = update.updateElements.find(el => el.label === 'Hora');
      const tipoElement = update.updateElements.find(el => el.label === 'Tipo de Novedad'); // Buscar el tipo
      let novedadElement, novedad;
      novedadElement = update.updateElements.find(el => el.label === 'Novedad');
      novedad = update.updateElements
        .filter(element => element.label !== 'Hora')
        .map(element => {
          // Concatenar el label con los valores de updateValues
          const values = element.updateValues
            .map(value => `${element.label}: ${value.value}`)
            .join(', ');
          return values || `${element.label}: N/A`; // Si no hay valores, mostrar el label con N/A
        })
        .filter(text => text) // Eliminar elementos vacíos
        .join(', '); // Unir todos los elementos con coma
      return {
        id: update.id,
        hora: horaElement?.updateValues[0]?.value || '',
        responsable:
          update.updateElements?.find(el => el.element?.id === 2 || el.element?.id === 5)
            ?.updateValues[0]?.createdUser?.username || '',
        novedad: novedadElement ? novedadElement.updateValues[0]?.value || '' : novedad,
        tipo: tipoElement?.updateValues[0]?.value || '',
        fecha:
          update.updateElements?.find(el => el.element?.id === 2 || el.element?.id === 5)
            ?.updateValues[0]?.createdUtc || '',
        updateElements: update.updateElements,
        updateType: update.updateType,
        updateArea: update.updateArea,
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
      };
    });
  }


  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(updateRecord: UpdateRecord): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar el objeto directamente
        readOnly: true, // Abrir en modo solo lectura
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  editUpdateRecord(updateRecord: any): void {
    if (!updateRecord.updateElements) {
      console.error('El objeto no tiene elementos de actualización:', updateRecord);
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar los datos del registro
        readOnly: false, // Permitir edición
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición realizada con éxito. Actualizando datos...');
        this.loadData(Constants.SEGURIDAD);
        this.loadData(Constants.PERSONAL);
      }
    });
  }

  deleteUpdateRecord(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: '¿Estás seguro de que deseas eliminar este registro?' },
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.updateRecordService.deleteUpdateRecord(id).subscribe({
          next: () => {
            console.log(`Registro con ID ${id} eliminado correctamente.`);
            this.loadData(Constants.SEGURIDAD);
            this.loadData(Constants.PERSONAL);
          },
          error: error => {
            console.error(`Error al eliminar el registro con ID ${id}:`, error);
          },
        });
      }
    });
  }

  onCheckboxChange(isMarked: boolean, updateRecordId: number): void {
    // Find the item in the data and temporarily update its state
    const dataArrays = [this.flattenedData[Constants.SEGURIDAD], this.flattenedData[Constants.PERSONAL]];
    let targetItem: any = null;
    
    for (const dataArray of dataArrays) {
      targetItem = dataArray.find(item => item.id === updateRecordId);
      if (targetItem) break;
    }

    if (targetItem) {
      const previousState = targetItem.isMarkedForClosure;
      targetItem.isMarkedForClosure = isMarked; // Optimistically update UI
      
      this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
        next: () => {
          console.log('Estado actualizado correctamente.');
        },
        error: error => {
          console.error('Error al actualizar el estado:', error);
          // Revert the UI state on error
          targetItem.isMarkedForClosure = previousState;
        },
      });
    }
  }

  onSelectAllChange(event: { checked: boolean; type: string; visibleData?: any[] }): void {
    const { checked, type } = event;
    let targetData: any[] = [];

    // Si tenemos visibleData, usar solo los datos visibles; si no, usar todos los datos
    if (event.visibleData && event.visibleData.length > 0) {
      targetData = event.visibleData;
    } else {
      // Determine which data array to work with based on the type
      if (type === 'seguridad') {
        targetData = this.flattenedData[Constants.SEGURIDAD];
      } else if (type === 'personal') {
        targetData = this.flattenedData[Constants.PERSONAL];
      }
    }

    if (targetData.length === 0) return;

    // Filtrar solo los elementos que realmente necesitan cambio de estado
    const itemsToUpdate = targetData.filter(item => {
      return item && item.id && item.isMarkedForClosure !== checked;
    });

    if (itemsToUpdate.length === 0) {
      console.log('Todos los elementos visibles ya tienen el estado deseado.');
      return;
    }

    // Store previous states for potential rollback (solo para elementos que van a cambiar)
    const previousStates = itemsToUpdate.map(item => ({
      id: item.id,
      isMarkedForClosure: item.isMarkedForClosure
    }));

    // Optimistically update only items that need to change
    itemsToUpdate.forEach(item => {
      item.isMarkedForClosure = checked;
    });

    // Create API calls only for items that need to change
    const apiCalls = itemsToUpdate.map(item =>
      this.updateRecordService.updateMarkForClosure(item.id, checked)
    );

    // Execute all API calls in parallel
    forkJoin(apiCalls).subscribe({
      next: (results) => {
        console.log(`Todos los elementos de ${type} fueron actualizados correctamente.`);
      },
      error: (error) => {
        console.error(`Error al actualizar elementos de ${type}:`, error);
        // Revert UI states on any error (solo para elementos que se intentaron cambiar)
        previousStates.forEach(prevState => {
          const item = itemsToUpdate.find(dataItem => dataItem.id === prevState.id);
          if (item) {
            item.isMarkedForClosure = prevState.isMarkedForClosure;
          }
        });
      }
    });
  }

  loadTabData(type: string): void {
    // Primero cargamos la estructura del formulario
    this.updateService.getUpdateByTypeAndArea(type, Constants.GENERAL).subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.updateData[type] = data[0]; // Guardar estructura del formulario
          this.formGroups[type] = this.fb.group(
            this.updateData[type].updateElements.reduce(
              (controls: { [key: string]: any }, element: any) => {
                controls[element.id.toString()] = this.fb.control(
                  '', // Inicializamos vacío
                  element.required ? Validators.required : null
                );
                return controls;
              },
              {}
            )
          );
  
          this.groupedData[type] = this.groupElements(this.updateData[type].updateElements);
  
          // Cargar datos del registro si existen
          this.loadFormData(type);
        } else {
          console.error(`No se encontró la estructura del formulario para el tipo ${type}`);
        }
      },
      error: (err) => {
        console.error(`Error al cargar la estructura del formulario para el tipo ${type}:`, err);
      },
    });
  }
  
  private loadFormData(type: string): void {
    this.updateRecordService.getUpdateRecordByTypeAndArea(type, Constants.GENERAL).subscribe({
      next: (records) => {
        if (records && records.length > 0) {
          const record = records[0]; // Solo hay un registro como máximo
          this.updateData[type].id = record.id; // Actualizamos el ID del registro
  
          // Mapear los valores al formulario y establecer updateValueId
          record.updateElements.forEach((element: any) => {
            const existingElement = this.updateData[type].updateElements.find(
              (e: any) => e.id === element.id
            );
            if (existingElement) {
              existingElement.updateValues = element.updateValues; // Establecer los valores desde el registro
            }
  
            // Mapear valores al formulario
            const control = this.formGroups[type].get(element.id.toString());
            if (control) {
              control.setValue(element.updateValues?.[0]?.value || '');
            }
          });
        } else {
          console.log(`No hay registros existentes para el tipo ${type}, se mostrará un formulario vacío.`);
          this.updateData[type].id = null; // Asegurarse de que no se considere como edición
        }
      },
      error: (err) => {
        console.error(`Error al cargar los datos del formulario para el tipo ${type}:`, err);
      },
    });
  }
  
  
  

  submitTabData(type: string): void {
    // Determinar si todos los elementos carecen de updateValueId
    const isEditMode = this.updateData[type].updateElements.some(
      (element: any) => element.updateValues?.[0]?.id
    );
  
    // Construir el payload
    const payload = {
      updateId: this.updateData[type].id, // Siempre existe
      updateValues: this.updateData[type].updateElements
        .filter((element: any) => element.element.name !== 'Label') // Filtrar Labels
        .map((element: any) => {
          const value = this.formGroups[type].get(element.id.toString())?.value || '';
          return {
            updateValueId: element.updateValues?.[0]?.id || null, // Usar el ID existente si está presente
            updateElementId: element.id,
            value: element.element.name === 'CheckBox' ? (value ? 'true' : 'false') : value,
          };
        }),
      shiftClosureType: '', // Ajusta el valor según sea necesario
    };
  
    // Determinar el servicio correcto según el modo
    const serviceCall = isEditMode
      ? this.updateRecordService.updateUpdateRecord(this.updateData[type].id, payload) // Actualización
      : this.updateRecordService.createUpdateRecord(payload); // Creación
  
    serviceCall.subscribe({
      next: () => {
        console.log(`Datos de ${type} ${isEditMode ? 'actualizados' : 'creados'} exitosamente`);
      },
      error: (err) => {
        if (err.status === 400 && err.error && err.error.errors) {
          this.handleValidationErrors(err.error.errors, type);
        } else {
          console.error(`Error al ${isEditMode ? 'actualizar' : 'crear'} datos de ${type}:`, err);
        }
      },
    });
  }
  
  
  
  

  handleValidationErrors(errors: { [key: string]: string[] }, type: string): void {
    Object.keys(errors).forEach(key => {
      const match = key.match(/UpdateValues\[(\d+)\]\.Value/);
      if (match) {
        const index = parseInt(match[1], 10); // Extraer el índice del campo
        const element = this.updateData[type]?.updateElements[index]; // Obtener el elemento por índice
        if (element) {
          const control = this.formGroups[type]?.get(element.id.toString());
          if (control) {
            // Directamente usar los mensajes proporcionados por el backend
            const errorMessages = errors[key].join('. ');
            control.setErrors({
              serverError: errorMessages,
            });
          }
        }
      }
    });
  }

  groupElements(elements: any[]): any[] {
    const groupsMap = elements.reduce((map, el) => {
      const groupKey = el.group || 'default'; // Manejar elementos sin grupo
      if (!map[groupKey]) {
        map[groupKey] = [];
      }
      map[groupKey].push(el);
      return map;
    }, {});

    return Object.keys(groupsMap).map(key => ({
      group: key === 'default' ? null : +key, // Convertir grupo a número si aplica
      elements: groupsMap[key],
    }));
  }
}
